<template>
  <div v-show="resumen.totalIngresar !== 0" class="separacion">
    <Divider>{{ $t('message.cuotas.tipo.' + resumen.id + '.titulo') }}</Divider>
    <v-data-table
      id="tblResumenCuotas"
      :headers="fields"
      :items="cuotasDeclaracionFiltered"
      :no-data-text="$t('message.cuotas.periodo.sinPeriodos')"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ $t('message.cuotas.elec.base.' + props.item.idBaseCo) }}
        </td>
        <td class="text-xs-center">
          {{ props.item.periodoConsumo | moment('DD-MMMM-YYYY') }}
        </td>
        <td class="text-xs-right">
          <Numeric
            id="baseImponible"
            :value="props.item.baseImponible"
            readonly
            currency="€"
          ></Numeric>
        </td>
        <td class="text-xs-right">
          <Numeric
            id="totalfacturacion"
            :value="props.item.tipo"
            :precision="precisionTipo"
            readonly
            currency="%"
          ></Numeric>
        </td>

        <td class="text-xs-right">
          <Numeric
            id="totalfacturacion"
            :value="props.item.cuotaTributaria"
            readonly
            currency="€"
          ></Numeric>
        </td>
      </template>
    </v-data-table>

    <v-layout class="grey lighten-4">
      <v-flex sm12 md8>
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex text-xs-left sm12 md4>
              <div class="total">Titular de la cuenta</div>
            </v-flex>
            <v-flex text-xs-left sm12 md6>
              <div>
                {{ resumen.id | datosBancariosTitular }}
              </div>
            </v-flex>
            <v-flex text-xs-left sm12 md4>
              <div class="total">Entidad Bancaria</div>
            </v-flex>
            <v-flex text-xs-left sm12 md6>
              <div>
                {{ resumen.id | datosBancariosEntidad }}
              </div>
            </v-flex>
            <v-flex text-xs-left sm12 md4>
              <div class="total">IBAN</div>
            </v-flex>
            <v-flex text-xs-left sm12 md6>
              <div>
                {{ resumen.id | datosBancariosIban }}
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex sm12 md4>
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap v-if="resumen.iva !== 0">
            <v-flex text-xs-left xs6>{{ $t('message.cuotas.resumen.totalCuota') }} </v-flex>
            <v-flex xs6>
              <Numeric
                id="totalcuota"
                v-model="resumen.total"
                :readonly="true"
                currency="€"
              ></Numeric
            ></v-flex>
          </v-layout>
          <v-layout row wrap v-if="resumen.iva !== 0">
            <v-flex text-xs-left xs6
              >{{ $t('message.cuotas.resumen.iva', { importe: resumen.iva }) }}
            </v-flex>
            <v-flex xs6>
              <Numeric
                id="totalcuota"
                v-model="resumen.importeIva"
                :readonly="true"
                currency="€"
              ></Numeric
            ></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex text-xs-left xs6>
              <div class="total">{{ $t('message.cuotas.resumen.totalIngreso') }}</div>
            </v-flex>
            <v-flex xs6>
              <div class="total">
                <Numeric
                  id="totalfacturacion"
                  :value="resumen.totalIngresar"
                  readonly
                  currency="€"
                ></Numeric>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { Divider, Numeric } from '@/components';
export default {
  name: 'resumenCuota',
  props: {
    resumen: {
      type: Object,
      required: false
    },
    cuotasDeclaracion: {
      type: Array,
      required: false
    }
  },
  components: {
    Divider,
    Numeric
  },
  data() {
    let fields = [
      {
        value: 'tipoBase',
        text: this.$tc('message.cuotas.periodo.tipoBase', 2),
        align: 'center',
        sortable: false
      },
      {
        value: 'periodo',
        text: this.$t('message.cuotas.periodo.periodo'),
        align: 'center',
        sortable: false
      },
      {
        value: 'base',
        text: this.$tc('message.cuotas.periodo.base', 2),
        align: 'right',
        sortable: false
      },
      {
        value: 'cr',
        text: this.$tc('message.cuotas.periodo.tipo', 2),
        align: 'right',
        sortable: false
      },
      {
        value: 'cuotaTributaria',
        text: this.$tc('message.cuotas.periodo.cuotaTributaria', 2),
        align: 'right',
        sortable: false
      }
    ];
    return { fields: fields, precisionTipo: 3 };
  },
  computed: {
    cuotasDeclaracionFiltered() {
      return this.cuotasDeclaracion.filter(item => item.idCuota === this.resumen.id);
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.separacion {
  margin-bottom: 8rem;
}
</style>
